/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  CashDrawerDTO,
  CashDrawerDTOOptional,
  CashDrawerDTOMetaI,
  CashDrawerDTOTrackedI,
} from "./cash-drawer-dto";
import { CashDrawerDTOTracked, CashDrawerDTOMeta } from "./cash-drawer-dto";

/**
 *
 * @export
 * @interface EditCashDrawersDTO
 */
export interface EditCashDrawersDTOOptional {
  /**
   *
   * @type {Array<CashDrawerDTO>}
   * @memberof EditCashDrawersDTO
   */
  cashDrawersEdited?: CashDrawerDTOOptional[];
}

export interface EditCashDrawersDTO extends EditCashDrawersDTOOptional {
  /**
   *
   * @type {Array<CashDrawerDTO>}
   * @memberof EditCashDrawersDTO
   */
  cashDrawersEdited?: CashDrawerDTO[];
}

export interface EditCashDrawersDTOTrackedI {
  /**
   *
   * @type {Array<CashDrawerDTO>}
   * @memberof EditCashDrawersDTO
   */
  cashDrawersEdited?: CashDrawerDTOTrackedI[];
  cashDrawersEditedIsSet: boolean;
}

transformDatesMap.set(
  "EditCashDrawersDTO",
  function (model: EditCashDrawersDTO) {
    const transformDatescashDrawersEdited =
      transformDatesMap.get("CashDrawerDTO");
    if (transformDatescashDrawersEdited) {
      model.cashDrawersEdited?.forEach((sub) => {
        transformDatescashDrawersEdited(sub);
      });
    }
  },
);

export type EditCashDrawersDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  cashDrawersEdited: PropertyMeta<CashDrawerDTOMetaI>;
}>;

export var EditCashDrawersDTOMeta: EditCashDrawersDTOMetaI =
  {} as EditCashDrawersDTOMetaI;
EditCashDrawersDTOMeta = typeMeta("EditCashDrawersDTO", {
  cashDrawersEdited: propertyMeta(
    "cashDrawersEdited",
    true,
    false,
    false,
    CashDrawerDTOMeta,
  ),
});

const metaI = EditCashDrawersDTOMeta;

registerMeta(() => {});

export class EditCashDrawersDTOTracked implements EditCashDrawersDTOTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  cashDrawersEdited__I?: CashDrawerDTOTracked[] = undefined;
  cashDrawersEditedIsSet: boolean = false;
  set cashDrawersEdited(v: undefined | CashDrawerDTOTracked[]) {
    if (v !== undefined) {
      this.cashDrawersEdited__I = v;
      this.cashDrawersEditedIsSet = true;
    } else {
      this.cashDrawersEdited__I = v || undefined;
      this.cashDrawersEditedIsSet = false;
    }
    this.changeTracker = true;
  }
  get cashDrawersEdited() {
    return this.cashDrawersEdited__I;
  }
  constructor(config?: EditCashDrawersDTOOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {
    this.cashDrawersEdited?.forEach((a) => a.setIds());
  }
  assignFrom(
    config: EditCashDrawersDTOOptional,
    options?: AssignOptions,
  ): EditCashDrawersDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.cashDrawersEdited &&
      this.cashDrawersEditedApplyFilter(optionsRequired.filter)
    ) {
      this.cashDrawersEdited = config.cashDrawersEdited?.map(
        (a) => new CashDrawerDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.cashDrawersEditedIsSet = false;
      else this.cashDrawersEditedIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): EditCashDrawersDTOTrackedI {
    const cloned = {} as EditCashDrawersDTOTrackedI;
    if (
      this.cashDrawersEditedIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.cashDrawersEditedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.cashDrawersEditedIsSet = true;
      cloned.cashDrawersEdited = this.cashDrawersEdited
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.cashDrawersEditedIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): EditCashDrawersDTOTrackedI {
    if (!this.cashDrawersEditedApplyFilter(filter))
      this.cashDrawersEditedIsSet = false;

    this.cashDrawersEdited?.forEach((a) => a.unassignAll(filter));
    return this;
  }
  cashDrawersEditedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EditCashDrawersDTOMeta.cashDrawersEdited,
      EditCashDrawersDTOMeta,
      this.cashDrawersEdited,
      this,
    );
  }
  cashDrawersEditedIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.cashDrawersEditedIsSet &&
      this.cashDrawersEditedApplyFilter(filter)
    )
      return true;

    return this.cashDrawersEdited?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.cashDrawersEditedIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
